import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import HypotekarnaKalkulacka from "./HypotekarnaKalkulacka";
import InvesticnaKalkulacka from "./InvesticnaKalkulacka";
import UrokyDetailStranka from "./components/UrokyDetailStranka";
import Login from "./pages/Login";
import Profil from "./pages/Profil";
import PrveSpustenie from "./pages/PrveSpustenie";
import ZabudnuteHeslo from "./pages/ZabudnuteHeslo";
import ResetHesla from "./pages/ResetHesla";
import AdminPouzivatelia from "./pages/AdminPouzivatelia";
import RequireAuth from "./auth/RequireAuth";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/app" replace />} />
      <Route path="/login" element={<Login />} />

      <Route
        path="/zabudnute-heslo"
        element={
          <ZabudnuteHeslo />
        }
      />

      <Route
        path="/reset-hesla"
        element={
          <ResetHesla />
        }
      />
      
      <Route
        path="/prve-spustenie"
        element={
          <RequireAuth>
            <PrveSpustenie />
          </RequireAuth>
        }
      />

      <Route
        path="/app"
        element={
          <RequireAuth>
            <HypotekarnaKalkulacka />
          </RequireAuth>
        }
      />

      <Route
        path="/investicie"
        element={
          <RequireAuth>
            <InvesticnaKalkulacka />
          </RequireAuth>
        }
      />

      <Route
        path="/profil"
        element={
          <RequireAuth>
            <Profil />
          </RequireAuth>
        }
      />

      <Route
        path="/sadzby"
        element={
          <RequireAuth>
            <UrokyDetailStranka />
          </RequireAuth>
        }
      />

      <Route
        path="/admin"
        element={
          <RequireAuth requireAdmin>
            <AdminPouzivatelia />
          </RequireAuth>
        }
      />

      <Route path="*" element={<Navigate to="/app" replace />} />
    </Routes>
  );
}